import React, {useEffect, useState } from 'react';
import axios from 'axios';
import Form_API from '../../components/Form_API/Form_API'
import Wrapper from '../../components/Wrapper/Wrapper'
import Wrapper_trade from '../../components/Wrapper_trade/Wrapper_trade'
import classes from '../../containers/Order_history/Order_history.module.css'
import bitcoin from '../../assets/logo/bitcoin.png'
import ethereum from '../../assets/logo/ethereum.png'
import litecoin from '../../assets/logo/litecoin.png'
import ripple from '../../assets/logo/Ripple.png'
import EOS from '../../assets/logo/eos.png'
import BNB from '../../assets/logo/bnb.png'
import doge from '../../assets/logo/doge.png'
import ada from '../../assets/logo/ada.png'
import link from '../../assets/logo/link.png'

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import Order_history_table from '../../components/Autotrader_Form/Order_history_table'
import User_currencies from '../../components/User_currencies/User_currencies'
import Footer from '../../components/Footer/Footer'
import Button from 'react-bootstrap/Button';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import check from '../../assets/logo/check.png'
import Image from 'react-bootstrap/Image';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Alert from '@mui/material/Alert';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import Toolbar from '../../components/Toolbar/Toolbar'
import Logout from '../../containers/Login/Logout'

const Order_history = () => {

  const isLoaded = useSelector(state => !state.profiledata.isFetching, shallowEqual);
  const value = useSelector(state => state.profiledata.value, shallowEqual);
  const top_currencies = useSelector(state => state.profiledata.top_currencies, shallowEqual);


  const [btc_trade, setBtc_trade] = useState(0);
  const [eth_trade, setEth_trade] = useState(0);
  const [usdt_trade, setUsdt_trade] = useState(0);
  const [bnb_trade, setBnb_trade] = useState(0);
  const [eos_trade, setEos_trade] = useState(0);
  const [xrp_trade, setXrp_trade] = useState(0);
  const [ltc_trade, setLtc_trade] = useState(0);
  const [doge_trade, setDoge_trade] = useState(0);
  const [ada_trade, setAda_trade] = useState(0);
  const [link_trade, setLink_trade] = useState(0);
  const [API_Key, setAPI_Key] = useState('');
  const [Secret, setSecret] = useState('');
  const [userinfo, setUserinfo] = useState([]);
  const [funds, setFunds] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [subscriptions, setSubscriptions] = useState(false);
  const [profit, setProfit] = useState(0.0);
  const [Autotrade, setAutotrade] = useState(false);
  const [value_momentum, setValue_momentum] = useState('');
  const [value_crash, setValue_crash] = useState('');
  const [autotrader_info, setAutotrader_info] = useState('');
  
  const [check_mark, setCheck_mark] = useState('');
  const [error, setError] = useState(false);
  const [error_info, setError_info] = useState('');








  const oyChangeMomentum = (event) => {

    setValue_momentum(event.target.value)

  }

  const oyChangeCrash = (event) => {
    setValue_crash(event.target.value)

  }




  const Momentum_crash_radio = () => {
    return (
      <div>

      <div className={classes.Header_configuration}> Momentum Alert </div>

      <div className={classes.Body_configuration}>
        <FormControl component="fieldset">
          <RadioGroup aria-label="momentum" name="momentum1" value={value_momentum} onChange={oyChangeMomentum}>
            <Row>
            <FormControlLabel value="M-1" control={<Radio />} label="Momentum Email Notification" />
              {check_mark[0]}
            </Row>

            <Row>

            <FormControlLabel value="M-2" control={<Radio />} label="Momentum Email Notification with Autotrade" />
            {check_mark[1]}
            </Row>

          </RadioGroup>
        </FormControl>

      </div>


      <div className={classes.Header_configuration}>Crash Protection</div>

      <div className={classes.Body_configuration}>
        <FormControl component="fieldset">
          <RadioGroup aria-label="crash" name="crash1" value={value_crash} onChange={oyChangeCrash}>

            <Row>
            <FormControlLabel value="C-1" control={<Radio />} label="Crash Email Notification" />
     
            {check_mark[2]}

            </Row>

            <Row>
            <FormControlLabel value="C-2" control={<Radio />} label="Crash Email Notification with Autotrade" />
            {check_mark[3]}
            </Row>
          </RadioGroup>
        </FormControl>
      </div>
      </div>


    )
  }

 
  const  check_mark_function =  (check_data) => {
    var check_momentum
    var check_momentum_buy
    var check_crash
    var check_crash_sell

    if (check_data.Momentum_buy) {
      check_momentum_buy =  <Image  className={classes.Image_check} src={check} roundedCircle />
      check_momentum = null

    } 
    else if (check_data.Momentum_alert && !check_data.Momentum_buy) {
      check_momentum =  <Image  className={classes.Image_check} src={check} roundedCircle />
      check_momentum_buy = null
    }
    else {
      check_momentum = null
      check_momentum_buy = null
    }

    if (check_data.Crash_sell) {
      check_crash_sell =  <Image  className={classes.Image_check} src={check} roundedCircle />
      check_crash = null

    } 
    else if (check_data.Crash_alert&& !check_data.Crash_sell) {
      check_crash=  <Image  className={classes.Image_check} src={check} roundedCircle />
      check_crash_sell = null
    }
    else {
      check_crash_sell =  null
      check_crash = null
    }


    return [check_momentum, check_momentum_buy, check_crash, check_crash_sell]


  }



  const autotrade_on = (asset) => {
    var url_trade = process.env.REACT_APP_API_BASEURL + "/api/tradeon"
    axios.post(url_trade, {
      btc_trade: btc_trade,
      eth_trade: eth_trade,
      bnb_trade: bnb_trade,
      eos_trade: eos_trade,
      xrp_trade: xrp_trade,
      ltc_trade: ltc_trade,
      doge_trade: doge_trade,
      ada_trade: ada_trade,
      link_trade: link_trade,
      email: localStorage.getItem('email'),
      Momentum_alert: value_momentum === "M-1" || value_momentum === "M-2" ? true : false,
      Momentum_buy: value_momentum === "M-2" ? true : false,
      Crash_alert: value_crash === "C-1" || value_crash === "C-2" ? true : false,
      Crash_sell : value_crash === "C-2" ? true : false

    }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .then(response =>  {
        toast.success(response.data);
        user_autotrade_props()


      })
      .catch(error =>  {

        toast.error(error.response.data.message);
      })
      .finally(function () {
        // always executed
      });
  }


  const user_autotrade_props = () => {
      var url_autotrade_props = process.env.REACT_APP_API_BASEURL + "/api/autotradeprops"

      axios.post(url_autotrade_props, {

        email: localStorage.getItem('email'),

      }, {
        headers: {
          'Authorization': localStorage.getItem('token')
        }
      })
        .then(response =>  {
          setBtc_trade(response.data.BTC_TRADE_AMOUNT);
          setEth_trade(response.data.ETH_TRADE_AMOUNT);
          setLtc_trade(response.data.LTC_TRADE_AMOUNT);
          setBnb_trade(response.data.BNB_TRADE_AMOUNT);
          setEos_trade(response.data.EOS_TRADE_AMOUNT);
          setXrp_trade(response.data.XRP_TRADE_AMOUNT);
          setDoge_trade(response.data.DOGE_TRADE_AMOUNT);
          setAda_trade(response.data.ADA_TRADE_AMOUNT);
          setLink_trade(response.data.LINK_TRADE_AMOUNT);
          setCheck_mark(check_mark_function(response.data));


          
        })
        .catch(error =>  {
  
          toast.error(error.response.data.message);
        })
        .finally(function () {
          // always executed
        });
  }



  const autotrade_off = (asset) => {
    var url_trade = process.env.REACT_APP_API_BASEURL + "/api/tradeoff"
    axios.post(url_trade, {

      email: localStorage.getItem('email'),

    }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .then(response => {
        toast.success(response.data);
        user_autotrade_props()


      })
      .catch(error =>  {

        toast.error(error.response.data.message);
      })
      .finally(function () {
        // always executed
      });
  }


  const userinfo_function = () => {
    var url_trade = process.env.REACT_APP_API_BASEURL + "/api/userinfo"


    axios.post(url_trade, {

      email: localStorage.getItem('email'),

    }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .then(response => {
        setUserinfo( sortHistory(response.data));


      })
      .catch(function (error) {


        toast.error(error);
      })
      .finally(function () {
        // always executed
      });
  }


  

  


  const mySubmitHandler = (event) => {

    var check2 = []

    var url_trade = process.env.REACT_APP_API_BASEURL + "/api/trade";
    event.preventDefault();

    setAlerts(check2)
    //alert("You are submitting " + this.state.API_Key);
    axios.post(url_trade, {
      API: API_Key,
      secret: Secret,
      email: localStorage.getItem('email'), 

    }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })

      .then(json => {

        toast.success("Operation Successful");
        setFunds(json.data )
      
      })

      .catch(err => {

        toast.error("Server error");

      })

  }



  const sortHistory = (data) => {


    var sorted_history = []

    sorted_history= [...data].sort(function (a, b) {
      var nameA, nameB

        nameA = new Date(a.date).getTime(); // ignore upper and lowercase
        nameB = new Date(b.date).getTime(); // ignore upper and lowercase
     
      if (nameA < nameB) {
        return 1;
      }
      if (nameA > nameB) {
        return -1;
      }
      return 0;
    })

    return sorted_history;
  }




  


  const myChangeHandlerAPI = (event) => {
    setAPI_Key(event.target.value )
  }

  const myChangeHandlerSecret = (event) => {
    setSecret(event.target.value );
  }

  const onchangeBTC = (event) => {
    setBtc_trade(event.target.value );
  }

  const onchangeETH = (event) => {
    setEth_trade(event.target.value );
  }
  const onchangeUSDT = (event) => {
    setUsdt_trade(event.target.value );
  }
  const onchangeBNB = (event) => {
    setBnb_trade(event.target.value );
  }
  const onchangeXRP = (event) => {
    setXrp_trade(event.target.value );
  }
  const onchangeEOS = (event) => {
    setEos_trade(event.target.value );
  }
  const onchangeLTC = (event) => {
    setLtc_trade(event.target.value );
  }


  const onchangeDOGE = (event) => {
    setDoge_trade(event.target.value );
  }
  const onchangeADA = (event) => {
    setAda_trade(event.target.value );
  }
  const onchangeLINK = (event) => {
    setLink_trade(event.target.value );
  }


  useEffect(() => {

    console.log("component did mount portfolio")
    
      user_autotrade_props()
      userinfo_function()


  }, []);



 





  if (true) {

    var symbol_logo
    function symbol(symbol_data) {

      if (symbol_data === "BTCUSDT") {
        symbol_logo = <img src={bitcoin} />

      }

      if (symbol_data === "ETHUSDT") {
        symbol_logo = <img src={ethereum} />

      }

      if (symbol_data === "LTCUSDT") {
        symbol_logo = <img src={litecoin} />

      }

      if (symbol_data === "XRPUSDT") {
        symbol_logo = <img src={ripple} />

      }

      if (symbol_data === "EOSUSDT") {
        symbol_logo = <img src={EOS} />

      }
      if (symbol_data === "BNBUSDT") {
        symbol_logo = <img src={BNB} />

      }


      if (symbol_data === "DOGEUSDT") {
        symbol_logo = <img src={doge} />

      }

      if (symbol_data === "ADAUSDT") {
        symbol_logo = <img src={ada} />

      }
      if (symbol_data === "LINKUSDT") {
        symbol_logo = <img src={link} />

      }

      return symbol_logo;
    }

    function class_price(value) {
      if ((Number(value)) > 0) {
        if ((Number(value)) > 0.8) {
          return classes.BoldGreen
        }
        return classes.Green
      }
      if ((Number(value)) < 0) {

        if ((Number(value)) < -0.8) {
          return classes.BoldRed
        }
        return classes.Red
      }
    }





    var button = ''

    if ((btc_trade > 0 || eth_trade > 0 || usdt_trade > 0 || bnb_trade > 0 || xrp_trade > 0 || eos_trade > 0 || ltc_trade > 0 || doge_trade > 0|| ada_trade > 0|| link_trade > 0)) {
      button =  <Button className={classes.Button} onClick={autotrade_on} variant="success"> Start Auto Trading</Button>

    }

    var rows = []
    var head = []

    if (funds.length > 0) {
      rows.push(<tr> <td>Symbol</td> <td>Free </td> <td>Locked </td></tr>)

    } else {
      head = [];
    }


    funds.map(item => (
      rows.push(<tr> <td>{item.asset}</td> <td>{item.free} </td> <td>{item.locked} </td></tr>)

    ));

  }


    if (false)
      return <div> Loading... </div>;

    else {

      return (



        <div>
          <Toolbar button={<Logout ></Logout>}></Toolbar>

          <div >
            <ToastContainer hideProgressBar={true}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable position={toast.POSITION.TOP_RIGHT}
              style={{ textAlign: "center" }} />

          </div>




          <div className={classes.Order_history}>



          <Wrapper_trade>

<Order_history_table 
                              off={autotrade_off} 
                              on={autotrade_on} 
                              userinfo={userinfo} 
                              momentum_crash={Momentum_crash_radio}
                              button2={button}
                              btc_trade={btc_trade === 0 ? null : btc_trade }   
                              eth_trade={eth_trade === 0 ? null : eth_trade}   
                              ltc_trade={ltc_trade === 0 ? null : ltc_trade}   
                              xrp_trade={xrp_trade === 0 ? null : xrp_trade}   
                              eos_trade={eos_trade === 0 ? null : eos_trade}   
                              bnb_trade={bnb_trade === 0 ? null : bnb_trade}  

                              doge_trade={doge_trade === 0 ? null : doge_trade}   
                              ada_trade={ada_trade === 0 ? null : ada_trade}   
                              link_trade={link_trade === 0 ? null : link_trade}  

                              onchangeBTC={onchangeBTC} 
                              onchangeETH={onchangeETH} 
                              onchangeLTC={onchangeLTC} 
                              onchangeXRP={onchangeXRP} 
                              onchangeEOS={onchangeEOS} 
                              onchangeBNB={onchangeBNB} 

                              onchangeDOGE={onchangeDOGE} 
                              onchangeADA={onchangeADA} 
                              onchangeLINK={onchangeLINK} 

                              userinfo_summary = {userinfo}
                              autotrader_info = {autotrader_info}
                              top_currencies = {top_currencies}
                  
                  >
                  
                  
</Order_history_table>
</Wrapper_trade>
     


          </div>

          <Footer></Footer>
        </div>

      )
    }

  }

export default Order_history;
